import * as Sentry from "@sentry/browser";
import * as React from "react";
import {Suspense} from "react";
import * as ReactDOM from "react-dom";
import ShopRatingSection from "./ShopRatingSection";

export class ShopRatingHandler {
  public static run(acordionElement: HTMLElement, headlineElement: HTMLElement | null): void {
    const shopId = Number(document.body.dataset.channel);
    const data = acordionElement.dataset.reactRating;

    if (!Number.isInteger(shopId)) {
      Sentry.captureException(new Error("SalesChannelId not found in DOM"));

      return;
    }

    if (data === undefined) {
      Sentry.captureException(new Error("Data attribute for Rating ItemIDs is missing or empty."));

      return;
    }

    Sentry.setExtra("SalesChannelId", shopId);

    const itemIds = data.split(",").map(Number);
    if (itemIds.length === 0) {
      Sentry.captureException(new Error("No itemIds available"));

      return;
    }

    ReactDOM.render(
      <Suspense fallback={"loading"}>
        <ShopRatingSection itemIds={itemIds} headlineElement={headlineElement} />
      </Suspense>,
      acordionElement,
    );
  }
}
